import '../styles/main.css';
import '../styles/index.css';

import { createApp, h } from 'vue';
import HomePage from '../pages/HomePage.vue';
import LevelHomePage from '../pages/LevelHomePage.vue';
import NavPage from '../pages/NavPage.vue';
import {
  getBuildPracticeCards,
  getTransitionxartCards,
  getTransformationCards,
  getVernaticsCards,
  getMusicxartCards,
} from '../composables/useNavCards.js';

const filename = window.location.pathname.split('/').pop();
// filename is now exactly 'level_home.html', 'home.html' etc — no false matches

const pageMap = {
  'home.html': () => createApp(HomePage),
  'level_home.html': () => createApp(LevelHomePage),
  'index2.html': () => createApp(LevelHomePage),
  'build_practice.html': () =>
    createApp({ render: () => h(NavPage, { cards: getBuildPracticeCards() }) }),
  'transitionxart.html': () =>
    createApp({ render: () => h(NavPage, { cards: getTransitionxartCards() }) }),
  'transformation.html': () =>
    createApp({ render: () => h(NavPage, { cards: getTransformationCards() }) }),
  'vernatics.html': () => createApp({ render: () => h(NavPage, { cards: getVernaticsCards() }) }),
  'musicxart.html': () => createApp({ render: () => h(NavPage, { cards: getMusicxartCards() }) }),
};

// Use exact match on filename instead of includes()
if (pageMap[filename]) pageMap[filename]().mount('#app');
